import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import kkTranslations from './locales/kk.json'
import ruTranslations from './locales/ru.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      kk: {
        translation: kkTranslations,
      },
      ru: {
        translation: ruTranslations,
      },
    },
    // Не задаём `lng` явно: иначе детектор из localStorage каждый раз
    // перебивается, и выбранный язык слетает при перезагрузке.
    fallbackLng: 'kk',
    supportedLngs: ['kk', 'ru'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
